import { toUnit as coreToUnit } from '@dinero.js/core';

/**
 * Get the amount of a Dinero object in units.
 *
 * @param dineroObject - The Dinero object to transform.
 * @param options.digits - The number of fraction digits to round to.
 * @param options.round - The rounding function to use.
 *
 * @returns The amount in units.
 */
export function toUnit() {
  for (var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++) {
    _ref[_key] = arguments[_key];
  }

  var dineroObject = _ref[0],
      options = _ref[1];
  var calculator = dineroObject.calculator;
  var toUnitFn = coreToUnit(calculator);
  return toUnitFn(dineroObject, options);
}